import { render } from "./CustomerHeadList.vue?vue&type=template&id=4a8e8036"
import script from "./CustomerHeadList.vue?vue&type=script&lang=js"
export * from "./CustomerHeadList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__